<script>
  import { SvelteToast, toast } from "@zerodevx/svelte-toast";
  import { onMount, setContext } from "svelte";
  import { Contract } from "etleneum";
  import store from "./etleneumAccountStore";
  import Header from "./components/Header.svelte";
  import Features from "./components/Features.svelte";
  import Tickets from "./components/TicketList.svelte";
  import BuyTicket from "./components/BuyTicket.svelte";

  export let CONTRACT;

  let state = null;
  let prize = null;
  let tickets = null;
  let ticketNum = null;
  let prepareCall = null;
  let stream = null;
  let ticketPrice = null;
  let canDraw = false;
  let tip;

  const options = {};

  // const CONTRACT = 'c680z7fefr'
  setContext("contract", Contract(CONTRACT));

  onMount(async () => {
    const CONT = await Contract(CONTRACT);
    state = await CONT.state();
    state.prize = await CONT.funds();
    prepareCall = CONT.prepareCall;
    stream = CONT.stream;
    tickets = Array.from({ length: 16 ** 3 + 1 }, (v, i) => ({
      number: i,
      user: null,
    })).map((c, i) => {
      c.user = state.tickets[i] ?? null;
      return c;
    });
    //let x = await CONT.loadCall("rjc45h9m311");
    tip = await (
      await fetch("https://mempool.space/api/blocks/tip/height")
    ).json();

    canDraw = tip > state.last_drawing + 144;
  });

  function validate(num) {
    if (!num) return;
    return tickets[num].user ? null : num;
  }

  function buyTicket(event) {
    if (!event.detail.num) {
      return toast.push("Bilhete indisponível");
    }
    if ($store.id) {
      ticketNum = validate(event.detail.num);
      if (ticketNum) {
        document.getElementById("buySection").scrollIntoView();
        document.getElementById("number").focus();
      }
    } else {
      toast.push(`Faça Log In primeiro!`);
    }
  }
</script>

<Header />
<main>
  {#if state}
    <Features info={state} {tip} />
    {#if $store.id}
      <BuyTicket
        num={ticketNum}
        {tickets}
        {validate}
        {prepareCall}
        {stream}
        sats={state.ticket_price_sats}
        {canDraw}
      />
    {/if}
    <Tickets {tickets} user={$store.id} on:ticketNumber={buyTicket} />
  {/if}
</main>
<footer>
  <b>MegaSats</b> é um
  <a href="https://etleneum.com/#/contract/c680z7fefr" target="_blank"
    >contracto Etleneum</a
  >. Todas as funcionalidades do MegaSats são definidas pelo contracto,
  imutáveis e consultáveis. Deve consultar e ler o código antes de chamar os
  métodos aqui.
</footer>
<SvelteToast {options} />

<style>
  :global(html, body) {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }
  :global(body) {
    font-size: 14px;
  }
  :global(section > header) {
    font-size: 1.25rem;
    padding-bottom: 1.25rem;
  }
  main {
    position: relative;
    text-align: center;
    max-width: 95%;
    margin: 0 auto;
  }

  footer {
    text-align: center;
    padding: 2rem;
    background: var(--neutral);
    margin-top: 5rem;
  }

  @media (min-width: 640px) {
    :global(body) {
      font-size: 16px;
    }

    :global(section > header) {
      font-size: 2rem;
      padding-bottom: 2rem;
    }

    main {
      max-width: 960px;
    }
  }
</style>
